/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ViewingInputs */

const cs_enum_viewing = /** @type {(inputs: Enum_ViewingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlídka`)
};

const en_enum_viewing = /** @type {(inputs: Enum_ViewingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewing`)
};

/**
* | output |
* | --- |
* | "Viewing" |
*
* @param {Enum_ViewingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_viewing = /** @type {((inputs?: Enum_ViewingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ViewingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_viewing(inputs)
	return cs_enum_viewing(inputs)
});